import { ManagerError } from '@common/utils/error-parser';
import { Pool } from '@generated/base-types';
import { PoolMetadataOldFragment } from '../../services/load-pool.generated';

export class LoadPool {
  public static readonly type = '[Pool] Load Pool';
  constructor(public readonly id: Pool['id']) {}
}

export class LoadPoolSuccess {
  public static readonly type = '[Pool] Load Pool Success';
  constructor(public pool: PoolMetadataOldFragment) {}
}

export class LoadPoolFailure {
  public static readonly type = '[Pool] Load Pool Failure';
  constructor(public readonly error: ManagerError) {}
}

export class ReloadPool {
  public static readonly type = '[Pool] Reload Pool';
}
